export default function Logo({ size = 24 }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="logo">
      <div className="relative" style={{ width: size + 8, height: size + 8 }}>
        <div className="absolute inset-0 rounded-md bg-gradient-to-br from-primary via-blue-500 to-violet-500 opacity-90" />
        <div className="absolute inset-[2px] rounded-[5px] bg-background flex items-center justify-center">
          <div className="h-1.5 w-1.5 rounded-full bg-gradient-to-br from-primary to-violet-500 pulse-soft" />
        </div>
        <div className="absolute -inset-0.5 rounded-md bg-gradient-to-br from-primary/40 to-violet-500/40 blur-sm -z-10" />
      </div>
      <span className="font-display font-black tracking-tight" style={{ fontSize: size * 0.78 }}>
        Local Pulse
      </span>
    </div>
  );
}
